// extracted by mini-css-extract-plugin
module.exports = {"button":"RemoveButtonTheme_button__2dDPt","icon":"RemoveButtonTheme_icon__2RQyt"};